"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Nav = () => {
  const pathname = usePathname();

  const navLinks = [
    { href: "/about", label: "About" },
    { href: "/blogs", label: "Blogs" },
    { href: "/contact", label: "Contact" },
    { href: "/privacy-policy", label: "Privacy Policy" },
  ];

  return (
    <nav className="pt-4 pb-10 neue_machina_regular">
      <ul className="flex gap-6 justify-center relative">
        {navLinks.map((link) => {
          const isActive = pathname === link.href;
          return (
            <li key={link.href}>
              <Link
                href={link.href}
                className={`transition-colors duration-200 underline underline-offset-4 ${
                  isActive
                    ? "color_red font-semibold hover:text-black"
                    : "hover:text-red-500 color_black"
                }`}
              >
                {link.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
